// extracted by mini-css-extract-plugin
module.exports = {"downloadApiRequestTemplateButton":"DownloadApiTemplateButton_downloadApiRequestTemplateButton__1l-9c"};